module.exports = __webpack_public_path__ + "static/media/Inter-Regular.eba36000.ttf";